import { EmptyState } from "@generalapplications/ui";

export type BlogEmptyStateProps = {
  selectedTag: string | null;
};

/** The index with a filter that matches nothing. */
export function BlogEmptyState({ selectedTag }: BlogEmptyStateProps) {
  return (
    <EmptyState
      variant="solid"
      title={`No articles matching "${selectedTag}" found.`}
    />
  );
}
